import React, { useEffect, useMemo, useState, useRef, Component } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { withFormik, Form } from "formik";
import PromiseWrapper from "../Utils/PromiseDialog";
import DialogComponentWrapper from "../Utils/DialogComponentWrapper";
import { FormRow, callSend, RadioRow } from "../Form/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
    validateSomething,
    validatePassword
} from "../../components/Form/Validations";
import { Checkbox } from "primereact/checkbox";

import { toast } from "react-toastify";
const sdb_converter_form = "sdb_converter_form";

class SDBConverterForm extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.status.edit && !this.props.status.edit) {
            this.props.resetForm();
        }
    }

    render() {
        const { resetForm, status = {}, setStatus, canEdit, data, errors, touched, t, handleSubmit, values } = this.props;
        if (!data) return null;
        const isEdit = canEdit && status.edit;

        return (
            <div>
                <form id={sdb_converter_form}>
                    <RadioRow
                        edit={isEdit}
                        dato={data.set_password}
                        nombre={t("sdb.set_password")}
                        trueNombre={t("sdb.manual")}
                        falseNombre={t("sdb.autogenerada")}
                        campo="set_password"
                    />
                    {values?.set_password &&
                        <FormRow
                            edit={isEdit}
                            dato2={data.password}
                            type2="password"
                            nombre2={t("sdb.password")}
                            campo2="password"
                            validate2={validatePassword}
                            error2={touched?.password && errors?.password && t(errors?.password)}
                            eyeForPassword
                        />}
                </form>
            </div>
        );
    }
}

const formValidate = (data) => {
    const errors = {};
    if (data && data.set_password) {
        const er = validatePassword(data.password);
        if (er !== undefined) errors.password = er;
    }
    return errors;
};

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            set_password: data.set_password,
            password: data.password
        };
    },
    validate: formValidate,
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        if (!props.cancel) actions.setStatus({ edit: false });
    }
})(withTranslation()(SDBConverterForm));

const SDBConverterDialog = ({ campoId, dialogState, setDialogState, setInfoDialog, update }) => {
    const { t, i18n } = useTranslation();
    const [ref, setRef] = useState(null);
    const promiseWrapper = useRef(null);
    const formikRef = useRef(false);
    const [info, setInfo] = useState({ isLoaded: false });
    const buttons = [
        {
            buttonModel: {
                cssClass: "e-primary",
                content: t("sass.conectar"),
                isPrimary: true,
            },
            click: () => {
                conectarSDBConverter();
            }
        }, {
            buttonModel: {
                cssClass: "e-danger",
                content: t("forms.cancel"),
                isPrimary: false,
            },
            click: () => {
                setDialogState({ visible: false });
            }
        }

    ];

    const formData = {
        set_password: true,
        password: null
    };

    useEffect(() => {
        if (info.isLoaded && info.data) {
            update(info.data);
            setInfo({ isLoaded: false });
            setInfoDialog({ data: info.data, visible: true });
        }
    }, [info]);

    const conectarSDBConverter = async (data, args) => {
        const answer = await promiseWrapper.current.getPromiseAnswer();
        if (answer) {
            callSend(`/farms/${campoId}/sdb/crear`, {}, data, t, setInfo);
            setDialogState({ visible: false });
            //ref.value = null;
        }

    };

    return (<div id='SDBDialog'>
        <PromiseWrapper
            ref={promiseWrapper}
            yesText={t("general.answerYes")} noText={t("general.answerNo")}
            headerText={t("sdb.crear.header")} contentText={t("sdb.crear.msg")}
        />

        <DialogComponentWrapper
            formikRef={formikRef} containerId="sdb-converter-form"
            t={t} dialogState={dialogState} setDialogState={setDialogState}
        >
            <FormikForm
                innerRef={formikRef}
                canEdit edit={dialogState.visible}
                data={formData}
                updateData={(data, args) => conectarSDBConverter(data, args)}
            />
        </DialogComponentWrapper>
    </div>);

};

const SDBConverterInfoDialog = ({ campoId, dialogState, setDialogState, update, acceso_limitado }) => {
    const { t, i18n } = useTranslation();
    const updatePromiseWrapper = useRef(null);
    const deletePromiseWrapper = useRef(null);
    const formikRef = useRef(false);
    const [edit, setEdit] = useState(false);
    const [info, setInfo] = useState({ isLoaded: false });
    const [changeInputType, setChangeInputType] = useState(false);

    const buttons = useMemo(() => [
        {
            buttonModel: {
                cssClass: "e-primary",
                content: t("forms.update"),
                isPrimary: true,
                disabled: !edit || acceso_limitado
            },
            click: ({ type }) => edit && type !== "keydown" && formikRef && formikRef.current.submitForm(),
        },
        {
            buttonModel: {
                cssClass: "e-danger",
                content: t("forms.delete"),
                isPrimary: false,
            },
            click: async () => {
                const answer = await deletePromiseWrapper.current.getPromiseAnswer();
                if (answer && dialogState?.data) {
                    callSend(`/farms/${campoId}/sdb/eliminar/${dialogState.data.usuario_id}`, {}, { esta_habilitado: false }, t, setInfo);
                    setDialogState({ visible: false });
                    //ref.value = null;
                }
            }
        },
        {
            click: () => { setDialogState({ visible: false }); },
            buttonModel: { cssClass: "e-flat", content: t("forms.cancel") }
        }

    ], [t, dialogState, setDialogState, campoId, edit, acceso_limitado]);

    const formData = {
        set_password: true,
        password: null
    };

    useEffect(() => {

        if (!dialogState.visible) {
            setEdit(false);
            setChangeInputType(false);
        }
    }, [dialogState.visible]);

    useEffect(() => {
        if (info.isLoaded && info.data) {
            update(info.data);
            setInfo({ isLoaded: false });
        }
    }, [info]);

    const formatoFecha = (date) => {
        const formatDate = (new Date(date)).toLocaleDateString(i18n.language);
        return formatDate;
    };

    const updateSDBConverter = async (data, args) => {
        if (edit && !acceso_limitado) {
            const answer = await updatePromiseWrapper.current.getPromiseAnswer();
            if (answer && dialogState?.data) {
                if (data.password === dialogState.data.password) {
                    toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                } else callSend(`/farms/${campoId}/sdb/update/${dialogState.data.usuario_id}`, {}, data, t, setInfo);

                setDialogState({ visible: false });
            }
        }
    };

    return (
        <div id='SDBDialog'>
            <PromiseWrapper
                ref={deletePromiseWrapper}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("sdb.eliminar.header")} contentText={t("sdb.eliminar.msg")}
            />

            <PromiseWrapper
                ref={updatePromiseWrapper}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("sdb.update.header")} contentText={t("sdb.update.msg")}
            />

            <DialogComponentWrapper
                formikRef={formikRef} containerId="sdb-converter-update-form"
                t={t} dialogState={dialogState} setDialogState={setDialogState} buttons={buttons}
                header={t("sdb.title")} width="800px"
            >
                {dialogState?.data && formData &&
                    <>
                        <div className='row linea-formulario'>
                            <div className='col-12 col-md-4 text-md-left mtem-05'>
                                <label className='boldie'>{t("sdb.email")}</label>
                            </div>
                            <div className='col-12 col-md-8 text-md-left mtem-05'>
                                {dialogState.data && <h6>{dialogState.data.email}</h6>}
                            </div>
                        </div>
                        <div className='row linea-formulario'>
                            <div className='col-12 col-md-4 text-md-left mtem-05'>
                                <label className='boldie'>{t("sdb.password")}</label>
                            </div>
                            <div className='col-12 col-md-8 text-md-left mtem-05'>
                                {dialogState.data && !changeInputType ?
                                    <>
                                        <input readOnly type="password" value={dialogState.data.password} />
                                        <span className="pointer" onClick={() => setChangeInputType(true)}><FontAwesomeIcon icon={faEye} color="gray" /></span>
                                    </>
                                    : <><input readOnly type="text" value={dialogState.data.password} />
                                        <span className="pointer" onClick={() => setChangeInputType(false)}><FontAwesomeIcon icon={faEyeSlash} color="gray" /></span>
                                    </>}
                            </div>
                        </div>
                        <div className='row linea-formulario'>
                            <div className='col-12 col-md-4 text-md-left mtem-05'>
                                <label className='boldie'>{t("sdb.fecha")}</label>
                            </div>
                            <div className='col-12 col-md-8 text-md-left mtem-05'>
                                {dialogState?.data?.created_at && <h6>{formatoFecha(dialogState.data.created_at)}</h6>}
                            </div>
                        </div>
                        <div className='row linea-formulario'>
                            <div className='col-12 col-md-4 text-md-left mtem-05'>
                                <label className='boldie'>{t("sdb.descripcion")}</label>
                            </div>
                            <div className='col-12 col-md-8 text-md-left mtem-05'>
                                {dialogState?.data?.descripcion && <span>{(dialogState.data.descripcion[i18n.language] ?? dialogState.data.descripcion["en"])}</span>}
                            </div>
                        </div>
                        {!acceso_limitado &&
                        <div className='row linea-formulario'>
                            <div className='col-12 col-md-4 text-md-left mtem-05'>
                                <label className='boldie'>{t("sdb.editar")}</label>
                            </div>
                            <div className='col-12 col-md-8 text-md-left mtem-05'>
                                <Checkbox onChange={e => setEdit(e.checked)} checked={edit} />
                            </div>
                        </div>}
                        {edit && <div className='row linea-formulario'>
                            <FormikForm
                                innerRef={formikRef}
                                canEdit={edit && !acceso_limitado} edit={dialogState.visible}
                                data={formData}
                                updateData={(data, args) => updateSDBConverter(data, args)}
                            />
                        </div>}
                    </>}
            </DialogComponentWrapper>
        </div>
    );

};

export { SDBConverterDialog, SDBConverterInfoDialog };
